import type { ReactNode, JSX } from 'react';
import { Navigate } from 'react-router-dom';

import { clearSession, getAccessToken, isTokenExpired } from '@/lib/session';

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props): JSX.Element {
  const token = getAccessToken();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  // OS-1710 — un token vencido no deja entrar ni mostrar datos: al login con el motivo.
  if (isTokenExpired(token)) {
    clearSession();
    return <Navigate to="/login?expired=1" replace />;
  }
  return <>{children}</>;
}
